export default __webpack_public_path__ + "static/media/39.7d820997.jpeg";